import { render, staticRenderFns } from "./termsEdit.vue?vue&type=template&id=580292c0&scoped=true&"
import script from "./termsEdit.vue?vue&type=script&lang=js&"
export * from "./termsEdit.vue?vue&type=script&lang=js&"
import style0 from "./termsEdit.vue?vue&type=style&index=0&id=580292c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580292c0",
  null
  
)

export default component.exports